<nav class="dop-dropdown bl-widget--active-state bl-height--100 bl-display--flex bl-align-items--center bl-cursor--pointer">
  @if (isAuthenticated && user) {
    <ea-context-menu
      [controllerInnerHtml]="userMenuControl"
      controllerClass="bl-display--flex"
      uniqueId="user-dropdown"
      xOrientation="right"
      yOrientation="bottom"
    >
    <ul>
      <li>
        <button type="button" class="dop-dropdown-item" id="go-to-dashboard" (click)="goToDashboard()">
          <i class="cu-grid"></i>
          {{ 'userDropdown/goToDashboard' | dictionary }}
        </button>
      </li>
      @if (showAccountlink) {
        <li class="bl-border-bottom--solid">
          <button type="button" class="dop-dropdown-item" id="account-link" (click)="goToDashboard()">
            <i class="icon cu-link"></i>
            {{ 'userDropdown/linkAccount' | dictionary }}
          </button>
        </li>
      }
      <li>
        <button type="button" class="dop-dropdown-item" id="log-out" (click)="logout()">
          <div class="bl-display--flex">
            <i class="cu-log-out bl-margin-right--4"></i>
            <div class="bl-flex--auto">
              {{ 'userDropdown/linkLogOut' | dictionary }}
              @if (displayId) {
                <span
                  class="bl-display--block bl-font-size--12 user-name-width"
                  [class.bl-ellipsis]="isMaxChar(user.email)"
                  [title]="isMaxChar(displayId) ? displayId : ''"
                >
                  {{ displayId }}
                </span>
              }
            </div>
          </div>
        </button>
      </li>
    </ul>
    </ea-context-menu>
  }
</nav>
